import { z } from 'zod';
/**
 * Source tools the graph ingests from. Every node carries a `source`
 * field set to one of these values — the matcher uses it to know which
 * identity columns to compare (e.g. `slack` carries handle + display
 * name + avatar; `email` carries email + display name; `salesforce`
 * carries email + name + employer).
 *
 * Adding a connector is a two-step change: append the source here, then
 * teach the inference rule + scoring algorithm what columns the
 * connector emits.
 */
export const GRAPH_SOURCE_TOOLS = [
    'slack',
    'email',
    'salesforce',
    'github',
    'stripe',
    'calendar',
    'internal',
];
export const GraphSourceTool = z.enum(GRAPH_SOURCE_TOOLS);
